/*
 * @Author: your name
 * @Date: 2021-03-01 14:34:24
 * @LastEditTime: 2021-06-02 09:36:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\programEditing\getters.js
 */
const getters = {
  getVdrListLength(state) { // webSocket连接对象
    return state.vdrList.length;
  },
};

export default getters;